import React                        from 'react';
import PropTypes                    from 'prop-types';
import Flux                         from '../../../flux/Flux';
import Translations                 from '../../../utils/Translations';
import DailybonusTodayOfferHeadLine from './DailybonusTodayOfferHeadLine';
import DailyBonusOfferBtn           from '../SubComponents/DailyBonusOfferBtn';
import OfferIcon                    from '../SubComponents/OfferIcon';
import VipBadge                     from '../SubComponents/VipBadge';

const {signature, offerBgs} = Flux.Constants.DailyBonuses;

class DailybonusTodayVipOneDayOffer extends React.Component {
	render() {
		const {offer, purchased, content, conditions, effect} = this.props;
		const {wPreview, model}                               = content ? content : {};
		const isVip                                           = Flux.Guest.isVip();
		const backgroundUrl                                   = isVip ? `url(${wPreview})` : `url(${offerBgs.VIP})`;
		return (
			<div className='dailybonus-today-item'>
				<DailybonusTodayOfferHeadLine
					purchased={purchased}
					offer={offer}
				/>
				<div className="dailybonus-today-item__wrapper">
					<div className="dailybonus-today-item__left-side" style={{backgroundImage: backgroundUrl}}>
						<div className="dailybonus-today-item__left-side--bottom-plate">
							<div className="dailybonus-today-item__left-side--bottom-plate__signature">{isVip && model ? model.name : signature.OFFER_VIP}</div>
						</div>
					</div>
					<div className="dailybonus-today-item__right-side">
						{!isVip && <VipBadge show={isVip} conditions={conditions} />}
						<div className="dailybonus-today-item__right-side__icon"><OfferIcon offer={offer} purchased={purchased} /></div>
						<div className="dailybonus-today-item__right-side__offer-effect">{isVip ?
							<span className='free365'>{Translations.get('Free')}</span> : 'VIP'}</div>
						<div className="dailybonus-today-item__right-side__title">{isVip ?
							<span className='exclusive365'>{Translations.get('ExclusiveWallpaper365')}</span> : Translations.get('ForOneDay365')}</div>
						{!isVip && <div className="dailybonus-today-item__right-side__description">{Translations.get('BenefitNow365')}</div>}
						<DailyBonusOfferBtn
							purchased={purchased}
							offer={offer}
							content={content}
							effect={effect}
						/>
					</div>
				</div>
			</div>
		);
	}
}

DailybonusTodayVipOneDayOffer.propTypes = {
	offer:      PropTypes.string,
	purchased:  PropTypes.bool,
	content:    PropTypes.object,
	effect:     PropTypes.object,
	quantity:   PropTypes.number,
	conditions: PropTypes.array,
};


export default DailybonusTodayVipOneDayOffer;